import "./Main.css";
import "./ResponsiveMain.css";
import useMain from "./useMain";
import SearchWasher from "./SearchWasher/SearchWasher.js";
import FavWasher from "./FavWasher/FavWasher";
import RecentlyUsed from "./RecentlyUsed/RecentlyUsed";
import { NavLink, Route, Routes } from "react-router-dom";
import { getTranslatedText as translate } from "../Localization/Translation";

const Main = () => {
  const { locale, mainTabClick, clickHamburger } = useMain();

  return (
    <div className="main-component">
      <div className="hamburger-third-level-container">
        <div className="hamburger-third-level" onClick={clickHamburger}>
          <span className="bar-third-level"></span>
          <span className="bar-third-level"></span>
          <span className="bar-third-level"></span>
        </div>
      </div>
      <div className="main-navbar main-navbar-laundries" dir="auto">
        <NavLink
          to="/Navbar/Home/Search"
          className="search-main-tab main-tab current-main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".search-main-tab")}
        >
          <span>{translate("search-main-tab", locale)}</span>
        </NavLink>
        <NavLink
          to="/Navbar/Home/Favorite"
          className="fav-main-tab main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".fav-main-tab")}
        >
          <span>{translate("fav-main-tab", locale)}</span>
        </NavLink>
        <NavLink
          to="/Navbar/Home/Recently"
          className="recently-main-tab main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".recently-main-tab")}
        >
          <span>{translate("recently-main-tab", locale)}</span>
        </NavLink>
      </div>

      <Routes>
        <Route path="Search" element={<SearchWasher />} />
        <Route path="Favorite" element={<FavWasher />} />
        <Route path="Recently" element={<RecentlyUsed />} />
        <Route path="Request" element={<FavWasher />} />
      </Routes>
    </div>
  );
};

export default Main;
